import { usePaginatedQuery, useUrlPaginatedQuery } from "@shared/hooks";
import type { PaginatedQueryParams } from "@shared/api";

import { ListUsersManagerialResponse, UserFilters } from "./users.types";

import { axiosGetData } from "@shared/api/clients";
import { useQuery } from "@tanstack/react-query";
import { User } from "../../types";

const USERS_ENDPOINT = "v1/managerial/users";
const USERS_QUERY_KEY = ["users"];
const USERS_FILTER_KEYS: (keyof UserFilters)[] = [
  "name",
  "email",
  "role",
  "sortOrder",
  "sortBy",
];

export const getUser = async (id: string): Promise<User> => {
  return axiosGetData<User>(`${USERS_ENDPOINT}/${id}`);
};

export const useUserQuery = (id: string, options = {}) => {
  return useQuery({
    queryKey: [...USERS_QUERY_KEY, id],
    queryFn: () => getUser(id),
    enabled: !!id,
    ...options,
  });
};

export const useUsersQuery = (params?: PaginatedQueryParams<UserFilters>) => {
  return usePaginatedQuery<ListUsersManagerialResponse, UserFilters>({
    endpoint: USERS_ENDPOINT,
    queryKeyBase: USERS_QUERY_KEY,
    params,
  });
};

export const useUsersUrlQuery = () => {
  return useUrlPaginatedQuery<ListUsersManagerialResponse, UserFilters>({
    endpoint: USERS_ENDPOINT,
    queryKeyBase: USERS_QUERY_KEY,
    filterKeys: USERS_FILTER_KEYS,
  });
};
